import { render, staticRenderFns } from "./SolicitudeDetailForm.vue?vue&type=template&id=4a7febc2"
import script from "./SolicitudeDetailForm.vue?vue&type=script&lang=js"
export * from "./SolicitudeDetailForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports